/**
 * Compute age in completed years given an ISO date string (YYYY-MM-DD).
 * Returns null for invalid / missing input so callers can branch on
 * "no birthdate known" vs "<18" vs ">=18".
 */
export function computeAgeYears(birthDateIso: string | null | undefined): number | null {
  if (!birthDateIso) return null;
  const bd = new Date(birthDateIso);
  if (Number.isNaN(bd.getTime())) return null;
  const now = new Date();
  let age = now.getUTCFullYear() - bd.getUTCFullYear();
  const m = now.getUTCMonth() - bd.getUTCMonth();
  if (m < 0 || (m === 0 && now.getUTCDate() < bd.getUTCDate())) age--;
  return age;
}
